

@if (displayLoader) {
  <mat-spinner [diameter]="60" [strokeWidth]="5"></mat-spinner>
} @else {
  <a class="compass__back__link"
    [routerLink]="getBackUrl()"
    [queryParams]="getBackQueryParams()">
    <mat-icon svgIcon="back"></mat-icon>
    <span>{{ goBackLinkName | translate }}</span>
  </a>
  <section>
    @if (parentItems$ | async; as parentItems) {
      <div class="compass-resources__header"
        [ngStyle]="{'background-image': 'url(' + (getMediaUrl(parentItems.theme?.get('medias'))) + ')'}"
        [ngClass]="{'compass-resources__header--no-medias':parentItems.theme?.get('medias').length === 0}"
        >
        <h2>{{ parentItems.theme.get('label') }}</h2>
        <div [innerHTML]="parentItems.theme.get('body') ?? parentItems.exploreItem?.get('description') ?? ''"></div>
      </div>
    }
    <div class="grid-compass compass-ressources__content">
      @for (resource of resources; track resource) {
        <app-compass-card
          class="compass-card--resources compass-card--resource compass-card--resource-{{getResourceType(resource, true)}}">
          <div data-header class="app-compass-card__header">
            <h3>{{ getResourceType(resource) }}</h3>
          </div>
          <div data-body class="app-compass-card__body"
               [ngClass]="{'app-compass-card__body--no-medias':resource.get('medias').length === 0}">
            <h4 [innerHTML]="resource.get('label')"></h4>
            <div [innerHTML]="resource.get('body')"></div>
          </div>
          <div data-footer class="app-compass-card__footer">
            @if (isDialogResource(resource)) {
              <button class="app-compass-card__footer__button" data-e2e="compass-resources-see-resource-dialog" (click)="onSeeResourceClick(resource)">
                <mat-icon svgIcon="app-compass-card__footer__button__icon"></mat-icon>
                <span>{{ 'compass.see_more' | translate }}</span>
              </button>
            } @else {
              <button class="app-compass-card__footer__button" data-e2e="compass-resources-open-resource-page" [routerLink]="['..', 'ressource', resource.id]"
                [queryParams]="getQueryParams()" [relativeTo]="activatedRoute">
                <mat-icon svgIcon="app-compass-card__footer__button__icon"></mat-icon>
                <span>{{ 'compass.see_more' | translate }}</span>
              </button>
            }
          </div>
        </app-compass-card>
      }
    </div>
  </section>
}
